import type { VideoJsPlayer } from './index'
import { putContinueWatchingVod, markVodAsWatched } from '/services/api/v3/vods'
import {
  putContinueWatchingEpisode,
  putContinueWatchingEpisodeBySeason,
} from '/services/api/v3/tvShows'
import { ContentType } from '/components/home/constants'

let videojs
let data

export const create = (player: VideoJsPlayer): void => {
  videojs = player
}

export const play = (source): void => {
  data = source
}

export const end = (): void => {
  const { id, type } = data
  if (id && type === ContentType.VOD) {
    markVodAsWatched(id)
  }
}

export const destroy = (): void => {
  const { id, tvShowId, seasonId, type } = data
  const currentTime = videojs?.currentTime()
  const duration = videojs?.duration()
  const ifContinueWatching = currentTime !== duration && currentTime > 60

  if (ifContinueWatching && id && type === ContentType.VOD) {
    putContinueWatchingVod(id, currentTime)
  }

  if (ifContinueWatching && id && type === ContentType.TV_SHOW && tvShowId) {
    if (seasonId) {
      putContinueWatchingEpisodeBySeason(id, tvShowId, currentTime, seasonId)
    } else {
      putContinueWatchingEpisode(id, tvShowId, currentTime)
    }
  }

  videojs = null
  data = null
}
